const updateLocalStorageAndStore = (key, data, updatedAt) => {
  const storeObject = {
    data: data,
    lastUpdated: updatedAt,
  };

  localStorage.setItem(key, JSON.stringify(storeObject));
};

const getItemFromLocalStorage = (key) => {
  return JSON.parse(window.localStorage.getItem(key));
};

const removeItemFromLocalStorage = (key) => {
  return window.localStorage.removeItem(key);
};

const checkLocalStorageForKey = (key) => {
  return window.localStorage.getItem(key) !== null;
};

const isExpired = (key, updatedAt) => {
  const storedItem = getItemFromLocalStorage(key);
  const timeCheck = storedItem ? storedItem.lastUpdated !== updatedAt : true;

  return timeCheck;
};

export default {
  updateLocalStorageAndStore,
  checkLocalStorageForKey,
  getItemFromLocalStorage,
  removeItemFromLocalStorage,
  isExpired,
};
